import { BreadcrumbItem, BreadcrumbProvider } from "./breadcrumb";
import { LocalizationService } from "../../localization/localization";

export class DefaultBreadcrumbProvider implements BreadcrumbProvider {
  private update: any;
  // @ngInject
  constructor(
    private $scope: ng.IScope,
    private $state: ng.ui.IStateService,
    private sdLocalizationService: LocalizationService
  ) {
    this.$scope.$on("$stateChangeSuccess", () => {
      if (!this.$scope.$ctrl.updateStateOnce) {
        if (this.update) {
          this.update();
        }
      }
    });
  }

  public registerUpdater(updatefn: () => {}) {
    this.update = updatefn;
    this.update();
  }

  get() {
    let items: BreadcrumbItem[] = [];
    let currentState: any = this.$state.$current;
    while (currentState && currentState.self.name) {
      if (currentState.self.navDisplayNameLocApp) {
        if (!currentState.self.navDisplayNameLocKey) {
          throw new Error("The localization key is missing, can't fetch the display name for state");
        } else {
          let displayName = this.sdLocalizationService.getLocalizedString(
            currentState.self.navDisplayNameLocApp,
            currentState.self.navDisplayNameLocKey
          );
          items.unshift({ displayName: displayName, type: "state", link: currentState.self.name });
        }
      }

      currentState = currentState.parent;
    }
    return items;
  }
}

export class DefaultBreadcrumbProviderFactory {
  // @ngInject
  constructor(private $state: ng.ui.IStateService, private sdLocalizationService: LocalizationService) {}
  create($scope: ng.IScope): DefaultBreadcrumbProvider {
    return new DefaultBreadcrumbProvider($scope, this.$state, this.sdLocalizationService);
  }
}
